// Central registry of data-testid values for LE 11.
// Keep keys grouped per page/area for easy lookup by QA & testing agents.

export const NAV = {
  brand: "nav-brand",
  linkHome: "nav-link-home",
  linkMenu: "nav-link-menu",
  linkCommander: "nav-link-commander",
  linkContact: "nav-link-contact",
  linkAdmin: "nav-link-admin",
  ctaCommander: "nav-cta-commander",
  mobileToggle: "nav-mobile-toggle",
  mobileSheet: "nav-mobile-sheet",
};

export const HOME = {
  root: "page-home",
  heroTitle: "home-hero-title",
  heroCtaCommander: "home-hero-cta-commander",
  heroCtaMenu: "home-hero-cta-menu",
  specialtyBurger: "home-specialty-burger",
  specialtyRolls: "home-specialty-rolls",
  specialtyMerguez: "home-specialty-merguez",
  specialtyPizza: "home-specialty-pizza",
  specialtyTandoor: "home-specialty-tandoor",
  specialtyIndian: "home-specialty-indian",
  infoBlock: "home-info-block",
};

export const MENU = {
  root: "page-menu",
  placeholderBurger: "menu-placeholder-burger",
  placeholderRolls: "menu-placeholder-rolls",
  placeholderMerguez: "menu-placeholder-merguez",
  placeholderPizza: "menu-placeholder-pizza",
  placeholderTandoor: "menu-placeholder-tandoor",
  placeholderIndian: "menu-placeholder-indian",
};

export const ORDER = {
  root: "page-commander",
  placeholder: "commander-placeholder",
};

export const CONTACT = {
  root: "page-contact",
  address: "contact-address",
  phone: "contact-phone",
  hours: "contact-hours",
  mapPlaceholder: "contact-map-placeholder",
};

export const ADMIN = {
  root: "admin-root",
  sidebar: "admin-sidebar",
  sidebarLinkDashboard: "admin-link-dashboard",
  sidebarLinkCommandes: "admin-link-commandes",
  sidebarLinkMenu: "admin-link-menu",
  sidebarLinkParametres: "admin-link-parametres",
  dashboard: "admin-page-dashboard",
  commandes: "admin-page-commandes",
  menu: "admin-page-menu",
  parametres: "admin-page-parametres",
};

export const FOOTER = {
  root: "site-footer",
};
